<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-container>
        <v-layout wrap pb-lg-12>
          <v-flex xs12 py-1 style="color: #8e8e8e">
            <router-link
              style="text-decoration: none; color: #8e8e8e"
              :to="{ name: 'cart' }"
            >
              Cart >
            </router-link>
            <router-link
              style="text-decoration: none; color: #8e8e8e"
              :to="{ name: 'cartinformation' }"
            >
              <span style="color: black"> Information</span> >
            </router-link>
            <router-link
              style="text-decoration: none; color: #8e8e8e"
              :to="{ name: 'cartshipping' }"
            >
              Shipping >
            </router-link>
            <router-link
              style="text-decoration: none; color: #8e8e8e"
              :to="{ name: 'cartpayment' }"
            >
              Payment
            </router-link>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout wrap>
              <v-flex
                pt-1
                pt-sm-2
                pt-md-2
                pt-lg-3
                pb-lg-5
                sm6
                style="font: 20px robotomedium"
                >Contact Information
              </v-flex>
              <v-flex
                class="hidden-md-and-down"
                py-3
                py-lg-0
                text-right
                py-lg-3
                sm12
                md12
                lg6
                style="font-family: robotoregular"
              >
                Already have an account? Log in
              </v-flex>
              <v-flex
                class="hidden-lg-and-up"
                py-3
                py-lg-0
                text-left
                py-lg-3
                sm12
                md12
                lg6
                style="font-family: robotoregular"
              >
                Already have an account? Log in
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  style="height: 26px"
                  class="textfd"
                  label="Email"
                  dense
                  outlined
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox label="Keep me sign in"> </v-checkbox>
              </v-flex>
              <v-flex xs12 pb-3 pb-lg-5 style="font: 20px robotomedium"
                >Shipping Address
              </v-flex>
              <v-flex sm6 pr-sm-1>
                <v-text-field class="textfd" dense outlined label="First Name">
                </v-text-field>
              </v-flex>
              <v-flex sm6 pl-sm-1>
                <v-text-field
                  class="textfd"
                  dense
                  outlined
                  tile
                  label="Last Name"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  class="textfd"
                  dense
                  outlined
                  tile
                  label="Company ( Optional)"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  class="textfd"
                  dense
                  outlined
                  tile
                  label="Address"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  class="textfd"
                  dense
                  outlined
                  tile
                  label="Apartment, Suite, etc"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field class="textfd" dense outlined tile label="City">
                </v-text-field>
              </v-flex>
              <v-flex sm4 pr-sm-1>
                <v-text-field
                  class="textfd"
                  dense
                  outlined
                  tile
                  label="Country"
                >
                </v-text-field>
              </v-flex>
              <v-flex sm4 px-sm-1>
                <v-text-field class="textfd" dense outlined tile label="State">
                </v-text-field>
              </v-flex>
              <v-flex sm4 pl-sm-1>
                <v-text-field class="textfd" dense outlined tile label="Pin">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  style="height: 26px"
                  color="grey"
                  class="textfd"
                  dense
                  outlined
                  label="Phone"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6 pl-sm-5 pt-6 pt-md-0 pl-lg-12>
            <v-layout wrap>
              <v-flex xs12 py-lg-8>
                <v-card flat v-for="(item, i) in cart" :key="i">
                  <v-layout wrap py-lg-3>
                    <v-flex xs2>
                      <v-img :src="mediaURL + item.productId.photos[0]"> </v-img>
                    </v-flex>
                    <v-flex xs8 pl-3>
                      <div style="font-family: robotobold">
                        {{item.productId.productName}}
                      </div>
                      <!-- <div
                        style="
                          font-family: robotoregular;
                          font-size: 12px;
                          padding-top: 2%;
                          padding-bottom: 2%;
                          color: grey;
                        "
                      >
                        500 ml
                      </div> -->
                      <div
                        style="
                          font-family: robotoregular;
                          font-size: 12px;
                          color: grey;
                        "
                      >
                        <span>QTY.{{item.quantity}} </span>
                      </div>
                    </v-flex>
                    <v-flex style="font-family: robotobold" text-right>
                      Rs. {{item.amount}}
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 py-3>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs6 class="regulartext">Subtotal </v-flex>
                  <v-flex xs6 text-right class="RM">Rs. {{tot.total}} </v-flex>
                  <v-flex xs6 class="regulartext">Shipping </v-flex>
                  <v-flex xs6 text-right class="RM">Free </v-flex>
                  <v-flex xs12 py-3>
                    <v-divider> </v-divider>
                  </v-flex>
                  <v-flex xs6 class="regulartext">Total </v-flex>
                  <v-flex xs6 text-right class="RM" style="font-size: 23px"
                    >Rs. {{tot.total}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-checkbox label="Save this information for next time.">
            </v-checkbox>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout>
              <v-flex xs6 sm6 md5>
                <v-btn
                  color="yellow"
                  tile
                  width="100%"
                  style="text-transform: none; color: white"
                  elevation="0"
                  >CONTINUE SHiPPING
                </v-btn>
              </v-flex>
              <v-flex xs6 sm6 md6 lg4 pl-3>
                <v-btn tile width="100%" outlined>RETURN TO CART</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      msg: "",
      timeout: 5000,
      snackbar: false,
      appLoading: false,
      ServerError: false,
      cart: [],
      tot: [],
      qty: 1,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/cart/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.cart = response.data.cart;
          this.tot = response.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #dddddd;
}
</style>